import { TimePicker } from "@mui/x-date-pickers";
import { format, isValid } from "date-fns";
import { FC } from "react";
import CancelIcon from '@mui/icons-material/Cancel';

interface TimeSelectorProps {
  value?: string;
  invalid?: boolean;
  onTimeChange: (time: string | undefined ) => void;
}

const TimeSelector: FC<TimeSelectorProps> = (props) => {
  return (
    <div className={`w-full shadow-main rounded-md flex flex-row items-center border box-border ${!!props.invalid ? 'border-red-500 border-solid' : 'border-transparent'}`}>
      <TimePicker
        ampm={false}  // This is the key prop to disable AM/PM
        views={['hours', 'minutes']}
        format="HH:mm"
        value={props.value ? new Date(2014, 8, 1, Number(props.value.split(":")[0]), Number(props.value.split(":")[1])) : undefined}
        className={'w-full bg-transparent rounded-md'}
        sx={{
            '& .MuiInputBase-input': {
            paddingX: '0.75rem',
            paddingY: '0.5rem'
            },
            '& .MuiOutlinedInput-notchedOutline': {
            border: 'none'
            }
        }}
        localeText={{
            okButtonLabel: 'Kinnita',
            cancelButtonLabel: 'Tühista',
            toolbarTitle: 'Vali aeg'
          }}
        slotProps={{ textField: { placeholder: 'tt:mm' }, field: { clearable: true }}}
        onChange={(v) => {
            if (v) {
              if (isValid(v)) props.onTimeChange(format(v, 'HH:mm'))
            } else {
                props.onTimeChange(undefined)
            }
        }}
        />
        {/* {
          props.value &&
          <div className="pr-2" onClick={() => props.onTimeChange(undefined)}>
            <CancelIcon className="text-gray-500" style={{width: '20px', height: '20px'}} />
          </div>
        } */}
    </div>
  );
};

export default TimeSelector;